"use client";
import { E as c, b as s, u as f } from "./useRenderElement-B8V3_e8R.mjs";
import { u as l } from "./useCompositeItem-qvQDnnMp.mjs";
function M(e) {
  const {
    render: E,
    className: d,
    state: t = c,
    props: o = s,
    refs: r = s,
    metadata: m,
    customStyleHookMapping: a,
    tag: p = "div",
    ...i
  } = e, {
    compositeProps: n,
    compositeRef: u
  } = l({
    metadata: m
  });
  return f(p, e, {
    state: t,
    ref: [...r, u],
    props: [n, ...o, i],
    customStyleHookMapping: a
  });
}
export {
  M as C
};
